import React from 'react'
import { useDispatch } from 'react-redux'
import { FaLayerGroup } from 'react-icons/fa'
import ControlButton from '../../../Buttons/ControlButton'

import { setBaseMapVisibly } from '../../../../redux/actions/map.actions'

export default function DownloadPoints() {
  const dispatch = useDispatch()

  const onSetBaseMapVisibly = () => {
    dispatch(setBaseMapVisibly(true))
  }

  return (
    <ControlButton
      icon={FaLayerGroup}
      ariaLabel="Download points"
      onClick={onSetBaseMapVisibly}
      customClass="ol-basemap-list"
    ></ControlButton>
  )
}
